import React, { useMemo } from 'react';
import {
  BotAvatar,
  ExpertAvatar,
  HeroesAvatar,
} from '@guuru/react-chat-avatar';
import { Profile, ProfileSection } from './style';

interface ChatAvatarProps {
  url?: string;
  isExpert: boolean;
  isBot: boolean;
  isHidden: boolean;
  showProfileImage: boolean;
  customBotAvatar?: string;
  isHeroesFormat?: boolean;
}

const ChatAvatar = function ({
  url = undefined,
  isExpert,
  isBot,
  showProfileImage,
  customBotAvatar = undefined,
  isHeroesFormat = false,
  isHidden,
}: ChatAvatarProps) {
  const role = useMemo(() => {
    if (isExpert) return 'Expert:';
    if (isBot) return 'Bot:';
    return 'User:';
  }, [isExpert, isBot]);

  if (isHidden) {
    return null;
  }

  return (
    <ProfileSection role="img" aria-label={role}>
      <Profile $isHeroesFormat={isHeroesFormat}>
        {showProfileImage && (
          (isHeroesFormat && <HeroesAvatar />)
          || (isExpert && <ExpertAvatar url={url} />)
          || (isBot && <BotAvatar customBotAvatar={customBotAvatar} />)
        )}
      </Profile>
    </ProfileSection>
  );
};

export default ChatAvatar;
